import { CONSULTANT_ROLES } from '@/common/constants/consultantRoles';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useState } from 'react';
import { RESULT_OPTIONS } from '../constants/resultOptions';
import { SELECT_DEFAULT_OPTION } from '../constants/selectDefaultOption';

const useSearchBox = ({ handleSearchCallback }) => {
	const results = [
		SELECT_DEFAULT_OPTION,
		...RESULT_OPTIONS.map((resultOption) => ({
			label: resultOption,
			value: resultOption,
		})),
	];

	const { commonData } = useCommonDataContext();

	const [selectedMarkets, setSelectedMarkets] = useState([]);
	const [selectedConsultants, setSelectedConsultants] = useState([]);
	const [selectedResult, setSelectedResult] = useState(results[0]);

	const markets = commonData.markets
		.sort((a, b) => a.name.localeCompare(b.name))
		.map((market) => ({ label: market.name, value: market._id }));
	const consultants = commonData.users
		.filter((user) => user.active && CONSULTANT_ROLES.includes(user.role))
		.sort((a, b) => a.name.localeCompare(b.name))
		.map((consultant) => ({
			label: consultant.name + ' ' + consultant.surname,
			value: consultant._id,
		}));

	const handleSearch = () => {
		const payload = {
			marketsIds: selectedMarkets.map((market) => market.value),
			consultantsIds: selectedConsultants.map((cons) => cons.value),
			selectedResultValue: selectedResult.value,
		};

		handleSearchCallback(payload);
	};

	return {
		markets,
		selectedMarkets,
		setSelectedMarkets,
		consultants,
		selectedConsultants,
		setSelectedConsultants,
		results,
		selectedResult,
		setSelectedResult,
		handleSearch,
	};
};

export default useSearchBox;
